// Quick View Modal for Product Cards
if (!customElements.get('quick-view-modal')) {
  customElements.define(
    'quick-view-modal',
    class QuickViewModal extends HTMLElement {
      constructor() {
        super();

        this.modal = this.querySelector('.quick-view-modal');
        this.dialog = this.querySelector('dialog');
        this.overlay = this.querySelector('.overlay');
        this.closeBtn = this.querySelector('.quick-view__close');
        this.loading = this.querySelector('.quick-view__loading');
        this.body = this.querySelector('.quick-view__body');

        this.isLoading = false;
        this.currentHandle = null;
        this.abortController = null;

        this.closeBtn?.addEventListener('click', () => this.hide());
        this.overlay?.addEventListener('click', () => this.hide());

        this.addEventListener('keyup', (evt) => {
          if (evt.code === 'Escape') this.hide();
        });
      }

      show() {
        if (!this.dialog || !this.modal) return;

        this.dialog.setAttribute('open', '');
        this.modal.classList.add('quick-view-modal--active');
        document.body.classList.add('quick-view-modal--open');

        if (typeof trapFocus === 'function') {
          trapFocus(this);
        }
      }

      hide() {
        if (!this.dialog || !this.modal) return;

        this.dialog.removeAttribute('open');
        this.modal.classList.remove('quick-view-modal--active');
        document.body.classList.remove('quick-view-modal--open');

        if (typeof removeTrapFocus === 'function') {
          removeTrapFocus(this);
        }

        setTimeout(() => {
          if (this.body) this.body.innerHTML = '';
          if (this.loading) this.loading.style.display = 'none';
        }, 300);
      }

      async loadProduct(handle) {
        if (!handle || this.isLoading) return;

        this.isLoading = true;
        this.currentHandle = handle;

        if (this.abortController) {
          this.abortController.abort();
        }
        this.abortController = new AbortController();

        if (this.body) {
          this.body.innerHTML = '';
        }

        if (this.loading) {
          this.loading.style.display = 'block';
          this.loading.innerHTML = `
            <div class="loading-overlay__spinner">
              <svg
                aria-hidden="true"
                focusable="false"
                role="presentation"
                class="spinner"
                viewBox="0 0 66 66"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
              </svg>
            </div>
          `;
        }

        this.show();

        try {
          const response = await fetch(`/products/${handle}?view=quickview`, {
            credentials: 'same-origin',
            headers: {
              'X-Requested-With': 'XMLHttpRequest',
            },
            signal: this.abortController.signal,
          });

          if (!response.ok) {
            throw new Error(`Failed to load product: ${response.status}`);
          }

          const html = await response.text();
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');

          const productSection =
            doc.querySelector('#QuickViewProduct-quick-view') ||
            doc.querySelector('[data-section="quick-view"]') ||
            doc.querySelector('.quick-view-section');

          if (!productSection) {
            throw new Error('Quick view section not found');
          }

          if (this.body) {
            this.body.innerHTML = productSection.outerHTML;
          }

          if (this.loading) {
            this.loading.style.display = 'none';
          }

          this.initializeQuickViewScripts(doc);
        } catch (error) {
          if (error.name !== 'AbortError') {
            console.error('Error loading product:', error);

            if (this.loading) {
              this.loading.style.display = 'block';
              this.loading.innerHTML = `<p>Error loading product. Please try again.</p>`;
            }
          }
        } finally {
          this.isLoading = false;
        }
      }

      initializeQuickViewScripts(doc) {
        if (!this.body) return;

        const scripts = doc.querySelectorAll('script[src]');

        scripts.forEach((script) => {
          if (!document.querySelector(`script[src="${script.src}"]`)) {
            const newScript = document.createElement('script');
            newScript.src = script.src;
            newScript.defer = true;
            document.head.appendChild(newScript);
          }
        });

        if (
          typeof yotpoWidgetsContainer !== 'undefined' &&
          yotpoWidgetsContainer &&
          typeof yotpoWidgetsContainer.initWidgets === 'function'
        ) {
          yotpoWidgetsContainer.initWidgets();
        }

        if (typeof window.initKlaviyoBackInStock === 'function') {
          window.initKlaviyoBackInStock({ isQuickView: true });
        }

        if (typeof window.bindKlaviyoQuickviewClose === 'function') {
          window.bindKlaviyoQuickviewClose();
        }
      }
    }
  );
}

if (!window.quickViewHandlerAttached) {
  window.quickViewHandlerAttached = true;

  document.addEventListener('click', (e) => {
    const quickViewBtn = e.target.closest('.product-card__quick-view-btn');
    if (!quickViewBtn) return;

    e.preventDefault();
    e.stopPropagation();    

    const handle = quickViewBtn.dataset.quickViewHandle;
    const modal = document.querySelector('quick-view-modal');

    if (!handle || !modal) return;

    modal.loadProduct(handle);
  });
}